import React from 'react';
import { useDispatch } from 'react-redux';

import Anchor from '../../../../components/link/Anchor';
import useMultiChannelDeliveryTracking from '../../../../hooks/queries/multiChannel/useMultiChannelDeliveryTracking';
import { appActions } from '../../../../store/modules/app';

interface OpenOrderDeliveryTrackingProps {
  deliveryId?: number;
}
const OpenOrderDeliveryTracking = ({ deliveryId }: OpenOrderDeliveryTrackingProps): JSX.Element => {
  const { mutate } = useMultiChannelDeliveryTracking();
  const dispatch = useDispatch();

  const handelClick = (): void => {
    if (!deliveryId) return;

    mutate(deliveryId, {
      onSuccess: ({ delivery }) => {
        dispatch(
          appActions.appToggleModal({
            name: 'deliveryTrackingModal',
            data: {
              kind: delivery.trackingHistories[0]?.kind,
              shipper: delivery.trackingHistories[0]?.manName,
              shipperPhone: delivery.trackingHistories[0]?.telno2,
              invoiceNumber: delivery.invoiceNumber,
              agent: delivery.enterpriseName,
              address: `${delivery.mainAddress} ${delivery.detailAddress}`,
              list: delivery.trackingHistories,
            },
          }),
        );
      },
    });
  };

  if (!deliveryId) {
    return <>-</>;
  }
  return <Anchor color="primary" isUnderLine={true} text="조회하기" onClick={handelClick} />;
};

export default OpenOrderDeliveryTracking;
